/* V_TBE_HP_06 | Shop Collection Section - HP
   Tab switching + horizontal scroll-snap carousel with arrows + pagination dots.
   Each panel is independent; we re-build dots on resize and on tab change so
   the visible-card count matches the layout. */
(function () {
  function initSection(section) {
    const tabs = section.querySelectorAll('[data-c-shop-tab]');
    const panels = section.querySelectorAll('[data-c-shop-panel]');

    panels.forEach(initPanel);

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-c-shop-tab');
        tabs.forEach((t) => {
          const isActive = t.getAttribute('data-c-shop-tab') === target;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', String(isActive));
        });
        panels.forEach((p) => {
          const isActive = p.getAttribute('data-c-shop-panel') === target;
          p.classList.toggle('is-active', isActive);
          if (isActive && typeof p._cShopRefresh === 'function') {
            p._cShopRefresh();
          }
        });
      });
    });
  }

  function initPanel(panel) {
    const track = panel.querySelector('[data-c-shop-track]');
    const prev = panel.querySelector('[data-c-shop-prev]');
    const next = panel.querySelector('[data-c-shop-next]');
    const dotsContainer = panel.querySelector('[data-c-shop-dots]');
    if (!track) return;

    const cards = () => track.querySelectorAll('.c-shopCollectionHP__card');

    function getStep() {
      const card = track.querySelector('.c-shopCollectionHP__card');
      if (!card) return track.clientWidth;
      const cardWidth = card.getBoundingClientRect().width;
      const gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0', 10) || 0;
      return cardWidth + gap;
    }

    function getVisibleCount() {
      const card = track.querySelector('.c-shopCollectionHP__card');
      if (!card) return 1;
      const cardWidth = card.getBoundingClientRect().width;
      if (!cardWidth) return 1;
      return Math.max(1, Math.round(track.clientWidth / cardWidth));
    }

    function buildDots() {
      if (!dotsContainer) return;
      const total = cards().length;
      const visible = getVisibleCount();
      const pages = Math.max(1, total - visible + 1);
      dotsContainer.innerHTML = '';
      const showDots = total > visible;
      dotsContainer.style.display = showDots ? '' : 'none';
      if (!showDots) return;
      for (let i = 0; i < pages; i++) {
        const dot = document.createElement('span');
        dot.className = 'c-shopCollectionHP__dot';
        if (i === 0) dot.classList.add('is-active');
        dotsContainer.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsContainer) return;
      const step = getStep();
      if (!step) return;
      const index = Math.round(track.scrollLeft / step);
      const dots = dotsContainer.querySelectorAll('.c-shopCollectionHP__dot');
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    }

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function updateArrowsVisibility() {
      const isScrollable = track.scrollWidth - track.clientWidth > 1;
      if (prev) prev.style.display = isScrollable ? '' : 'none';
      if (next) next.style.display = isScrollable ? '' : 'none';
    }

    function updateArrowAnchor() {
      const imgEl = track.querySelector('.c-shopCollectionHP__cardImg');
      if (!imgEl) return;
      const h = imgEl.getBoundingClientRect().height;
      if (h) panel.style.setProperty('--c-shop-cardimg-h', h + 'px');
    }

    function refresh() {
      buildDots();
      updateDots();
      updateArrowsVisibility();
      updateArrowAnchor();
    }

    if (prev) {
      prev.addEventListener('click', () => {
        const max = getMaxScroll();
        if (track.scrollLeft <= 1) {
          track.scrollTo({ left: max, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        }
      });
    }
    if (next) {
      next.addEventListener('click', () => {
        const max = getMaxScroll();
        if (track.scrollLeft >= max - 1) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: getStep(), behavior: 'smooth' });
        }
      });
    }

    track.addEventListener(
      'scroll',
      () => {
        updateDots();
      },
      { passive: true }
    );

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refresh, 120);
    });

    window.addEventListener('load', refresh);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(refresh).observe(track);
    }

    track.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', refresh, { once: true });
    });

    panel._cShopRefresh = refresh;
    refresh();
  }

  function init() {
    document.querySelectorAll('[data-c-shop-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* V_TBE_PDP_04 | PDP - Save x% vs $x
   Main price save label is rendered by c-save-label.liquid. Kaching bundle
   bars are rendered client-side, so we inject a matching .c-saveLabel into
   each bar. To stay robust against Kaching markup changes, prices are picked
   up from any money-formatted text inside the bar (max = compare-at,
   min = current). CSS in c-custom.css toggles percent vs dollar per variant. */
(function () {
  const BAR_SELECTOR = '.kaching-bundles__bar, .kaching-bundles__bar-container';
  const MONEY_RE = /([€$£¥])\s*([\d,]+(?:\.\d+)?)|([\d,]+(?:\.\d+)?)\s*([€$£¥])/g;

  function isActive() {
    return (
      document.body.classList.contains('c-saveLabel-varA') ||
      document.body.classList.contains('c-saveLabel-varB')
    );
  }

  function collectPricesInBar(bar) {
    const prices = [];
    const walker = document.createTreeWalker(bar, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement && node.parentElement.closest('.c-saveLabel--injected')) continue;
      const text = node.nodeValue;
      MONEY_RE.lastIndex = 0;
      let m;
      while ((m = MONEY_RE.exec(text)) !== null) {
        const symbol = m[1] || m[4] || '$';
        const valueStr = (m[2] || m[3]).replace(/,/g, '');
        const value = parseFloat(valueStr);
        if (value > 0) prices.push({ value, symbol, node });
      }
    }
    return prices;
  }

  function formatPercent(value) {
    const rounded = Math.round(value * 100) / 100;
    return `${rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(2)}%`;
  }

  function formatDollar(amount, symbol) {
    return `${symbol || '$'}${amount.toFixed(2)}`;
  }

  function buildLabel(percentText, dollarText) {
    const wrap = document.createElement('span');
    wrap.className = 'c-saveLabel c-saveLabel--injected';
    const pct = document.createElement('span');
    pct.className = 'c-saveLabel-percent';
    pct.textContent = `Save ${percentText}`;
    const dol = document.createElement('span');
    dol.className = 'c-saveLabel-dollar';
    dol.textContent = `Save ${dollarText}`;
    wrap.append(pct, dol);
    return wrap;
  }

  function chooseMount(bar, referenceNode) {
    if (referenceNode && referenceNode.parentElement) {
      const parent = referenceNode.parentElement;
      return parent.parentElement || parent;
    }
    return bar;
  }

  function updateBar(bar) {
    const existing = bar.querySelector(':scope > .c-saveLabel--injected, :scope .c-saveLabel--injected');
    const prices = collectPricesInBar(bar);
    if (prices.length < 2) {
      if (existing) existing.remove();
      return;
    }
    let maxPrice = prices[0];
    let minPrice = prices[0];
    for (const p of prices) {
      if (p.value > maxPrice.value) maxPrice = p;
      if (p.value < minPrice.value) minPrice = p;
    }
    if (maxPrice.value <= minPrice.value) {
      if (existing) existing.remove();
      return;
    }
    const saved = maxPrice.value - minPrice.value;
    const percentText = formatPercent((saved / maxPrice.value) * 100);
    const dollarText = formatDollar(saved, maxPrice.symbol);
    const signature = `${percentText}|${dollarText}`;

    if (existing) {
      if (existing.dataset.sig === signature) return;
      existing.remove();
    }
    const label = buildLabel(percentText, dollarText);
    label.dataset.sig = signature;
    chooseMount(bar, maxPrice.node).appendChild(label);
  }

  function scan() {
    if (!isActive()) {
      document.querySelectorAll('.c-saveLabel--injected').forEach((el) => el.remove());
      return;
    }
    document.querySelectorAll(BAR_SELECTOR).forEach(updateBar);
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      scan();
    });
  }

  function init() {
    scan();
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        const t = m.target;
        if (t && t.closest && t.closest('.c-saveLabel--injected')) continue;
        schedule();
        return;
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('ig:ready', schedule);
})();
